export default __webpack_public_path__ + "static/media/stock.0e726643.svg";